import React from "react";
import { Box } from "@mui/material";

const sx = {
  card: {
    border: "none",
    marginBottom: "30px",
    display: "flex",
    flexDirection: "row",
    borderRadius: "5px",
    justifyContent: "space-between",
    alignItems: "center",
    padding: "10px 15px",
    backgroundColor: "common.white",
    height: "100%",
    width: "390px",
    color: "darkBlue.c70"
  }
};

export default function Card({ content }) {
  return <Box sx={sx.card}>{content}</Box>;
}
